import { Action } from "redux";
import { FontsResponse } from "../../server/types/index.js";
import { Font, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["GET_FONTS_SUCCESS", "GET_FONTS_START"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetFontsStart = ActionBase<"GET_FONTS_START">;
type GetFontsSuccess = ActionBase<"GET_FONTS_SUCCESS"> & { fonts: Font[] };

export type FontsAction = GetFontsStart | GetFontsSuccess;

export const isFontsAction = (action: Action): action is FontsAction =>
  isActionType(action, ActionTypeKeys);

export const getFonts = (): ThunkAction<Promise<void>> => {
  return (dispatch, getState) => {
    const loadState = getState().loadStates.fonts;
    if (loadState !== "unloaded") {
      return Promise.resolve();
    }

    dispatch(getFontsStart());

    return fetch({ dispatch, authorize: false })
      .get<FontsResponse>("fonts")
      .then((res) => {
        res.data;
        dispatch(getFontsSuccess(res.data.fonts));
      })
      .catch((error) => {
        dispatch(showAlert("Die Schriftarten konnten nicht geladen werden!"));
        throw error;
      });
  };
};

const getFontsStart = (): GetFontsStart => ({ type: "GET_FONTS_START" });

export const getFontsSuccess = (fonts: Font[]): GetFontsSuccess => ({
  type: "GET_FONTS_SUCCESS",
  fonts,
});
